export const KANBAN_ATUALIZAR_LOTE_LAMINAS = 'KANBAN_ATUALIZAR_LOTE_LAMINAS';
export const atualizarLamina = (laminas) => ({
  type: KANBAN_ATUALIZAR_LOTE_LAMINAS,
  payload: {
    laminas,
  },
});
export const KANBAN_ATUALIZAR_MOVER_DISABLED = 'KANBAN_ATUALIZAR_MOVER_DISABLED';
export const atualizarMoverDisabled = (moverDisabled) => ({
  type: KANBAN_ATUALIZAR_MOVER_DISABLED,
  payload: {
    moverDisabled,
  },
});
export const KANBAN_ATUALIZAR_MODAL = 'KANBAN_ATUALIZAR_MODAL';
export const atualizarModal = (modal) => ({
  type: KANBAN_ATUALIZAR_MODAL,
  payload: {
    modal,
  },
});
export const KANBAN_ATUALIZAR_NOVAS_LAMINAS = 'KANBAN_ATUALIZAR_NOVAS_LAMINAS';
export const atualizarNovasLaminas = (novasLaminas) => ({
  type: KANBAN_ATUALIZAR_NOVAS_LAMINAS,
  payload: {
    novasLaminas,
  },
});


// WEBPACK FOOTER //
// ./src/componentes/dragdrog/store/kanban.action.js